// extracted by mini-css-extract-plugin
module.exports = {"progress":"ProgressKpi_progress__3iDie"};